import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const CartIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M4 7H20V20H4V7Z"
        stroke={color}
      />
    </svg>
  );
};

export default CartIcon;
